import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useHousehold } from "@/context/HouseholdContext";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Vault, SignOut } from "@phosphor-icons/react";
import { ROLE_LABELS } from "@/lib/api";
import { toast } from "sonner";

export default function Onboarding() {
  const { reload, setActiveId } = useHousehold();
  const { logout } = useAuth();
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [invites, setInvites] = useState([]);

  useEffect(() => { api.get("/invites/pending").then((r) => setInvites(r.data)).catch(() => {}); }, []);

  const create = async () => {
    if (!name.trim()) { toast.error("Give your household a name"); return; }
    setBusy(true);
    try {
      const res = await api.post("/households", { name });
      await reload(); setActiveId(res.data.id);
      toast.success("Household created");
      window.location.href = "/networth";
    } catch (e) { toast.error("Could not create household"); }
    finally { setBusy(false); }
  };

  const accept = async (token) => {
    try {
      const res = await api.post("/invites/accept", { token });
      await reload(); setActiveId(res.data.household_id);
      toast.success("You've joined the household");
      window.location.href = "/networth";
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not accept invite"); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-md space-y-8 animate-fade-up">
        <div className="flex items-center gap-2"><Vault size={26} weight="fill" /><span className="font-display font-black text-xl tracking-tight">CONTINUITY</span></div>

        {invites.length > 0 && (
          <div className="bg-card border border-border rounded-sm p-5 space-y-3">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-muted-foreground">You've been invited</p>
            {invites.map((inv) => (
              <div key={inv.id} className="flex items-center justify-between gap-3 border border-border rounded-sm p-3">
                <div><p className="font-semibold">{inv.household_name}</p><p className="text-xs text-muted-foreground">Role: {ROLE_LABELS[inv.role] || inv.role}</p></div>
                <Button data-testid={`accept-invite-${inv.id}`} onClick={() => accept(inv.token)} className="rounded-sm font-semibold">Accept</Button>
              </div>
            ))}
          </div>
        )}

        <div className="bg-card border border-border rounded-sm p-6 space-y-4">
          <div>
            <h1 className="font-display text-2xl font-black tracking-tight">Create your household</h1>
            <p className="text-sm text-muted-foreground mt-1">A household is the shared system of record for your family's wealth. You'll be Operator A and can invite your co-operator and advisors next.</p>
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider font-bold">Household name</Label>
            <Input data-testid="household-name-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. The Foy Family Office" className="rounded-sm mt-1.5" />
          </div>
          <Button data-testid="create-household-button" onClick={create} disabled={busy} className="w-full h-11 font-semibold rounded-sm">{busy ? "Creating…" : "Create Household"}</Button>
        </div>

        <button onClick={logout} className="text-xs text-muted-foreground flex items-center gap-1 hover:text-foreground mx-auto"><SignOut size={14} /> Sign out</button>
      </div>
    </div>
  );
}
